const NotFound = () => {
  return (
    <div className="mx-auto w-full max-w-[1200px]">
      <div className="rounded-3xl border border-white/60 bg-white/80 p-10 text-center shadow-lg shadow-slate-200/60">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
          404
        </p>
        <h1 className="mt-4 text-3xl font-semibold text-slate-900">
          Page not found
        </h1>
        <p className="mt-3 text-sm text-slate-500">
          The page you are looking for does not exist yet.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
